import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsAreasAreaEditRoute extends Route {
  model() {
    return this.modelFor('settings.areas.area');
  }
}

export default instrumentRoutePerformance(SettingsAreasAreaEditRoute);
